import { Link } from "gatsby";
import React from "react";
import styled from "styled-components";
import { BOX_SHADOW, PALETTE } from "../consts/Colors";
import { facebook, instagram, twitter } from "../consts/SVG";

export default function Footer() {
  return (
    <FooterContainer>
      {/* <FooterDiv>
        More About Us
        <p></p>
      </FooterDiv> */}
      <Bottom>
        <div>
          FOLLOW US
          <Icons>
            <a
              href="https://www.facebook.com/cafehouse5"
              target="_blank"
              rel="noreferrer"
            >
              <SingleIcon>{facebook}</SingleIcon>
            </a>
            <a
              href="https://www.facebook.com/cafehouse5"
              target="_blank"
              rel="noreferrer"
            >
              <SingleIcon>{twitter}</SingleIcon>
            </a>
            <a
              href="https://www.instagram.com/house__5/"
              target="_blank"
              rel="noreferrer"
            >
              <SingleIcon>{instagram}</SingleIcon>
            </a>
          </Icons>
        </div>
        <div>
          IMPORTANT LINKS
          <LINKS>
            <Link to="/">
              <SingleIcon>HOME</SingleIcon>
            </Link>
            <Link to="/#location">
              <SingleIcon>LOCATION</SingleIcon>
            </Link>
            <Link to="/#about">
              <SingleIcon>ABOUT</SingleIcon>
            </Link>
            <Link to="/menu">
              <SingleIcon>MENU</SingleIcon>
            </Link>
          </LINKS>
        </div>
        <div>
          CONTACT US
          <LINKS>Write to us at housepanch@gmail.com</LINKS>
        </div>
      </Bottom>
      <HR />
      <Copyright>
        <div>&copy; {new Date().getFullYear()} HOUSE 5</div>
      </Copyright>
    </FooterContainer>
  );
}

const FooterContainer = styled.div`
  left: 0px;
  bottom: 0px;
  padding: 0px 0px;
  background-color: ${PALETTE.BROWN};
  color: #ffffff;
  font-family: "Baloo 2";
`;

const FooterDiv = styled.div`
  padding: 10px 80px;
  background-color: ${PALETTE.BROWN};
`;

const Bottom = styled.div`
  margin: 10px 80px;
  padding: 20px 0px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-weight: 700;
  @media (max-width: 600px) {
    padding: 10px 0px;
    margin: 10px 10px;
    flex-direction: column;
  }
`;

const Icons = styled.div`
  display: flex;
  padding-top: 10px;
  @media (max-width: 600px) {
    padding-top: 5px;
  }
`;

const LINKS = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 10px;
  font-weight: 500;
  @media (max-width: 600px) {
    padding-top: 5px;
  }
`;

const HR = styled.div`
  border-bottom: 2px solid white;
  margin: 0px 20px;
  padding: 0px 0px;
  opacity: 0.3;
`;

const SingleIcon = styled.div`
  padding-right: 20px;
  padding-bottom: 7px;
  &:hover {
    transform: scale(1.1);
  }
  @media (max-width: 600px) {
    padding-right: 10px;
    padding-bottom: 7px;
  }
`;

const Copyright = styled.div`
  padding: 5px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  color: ${PALETTE.WHITE};
`;
